const { expect } = require('chai');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

describe('Duplicate content types', () => {
  describe('preview duplicating a single content type with a new name and id', () => {
    const mock = loadRecordedMock('duplicate_contentType_preview.json');
    it(`should return one transformed content type`, (done) => {
      migratortronApi.post(
        'duplicate?contentType',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          const contentTypes = body.contentTypes;
          expect(contentTypes).to.be.an('array');
          expect(contentTypes).to.have.a.lengthOf(1);

          const ct = contentTypes[0];
          expect(ct.id).to.equal('resourcePickers');
          expect(ct.name['en-GB']).to.equal('Resource pickers');

          done();
        }
      );
    });
  });

  describe('duplicate a single content type with a new name and id', () => {
    const mock = loadRecordedMock('duplicate_commit_contentType.json');
    it(`should create one new content type`, (done) => {
      migratortronApi.post(
        'duplicate/commit?contentType',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(body.committed).to.equal(true);

          const contentTypes = body.contentTypes;
          expect(contentTypes).to.be.an('array');
          expect(contentTypes).to.have.a.lengthOf(1);

          const ct = contentTypes[0];
          expect(ct.id).to.equal('resourcePickers');
          expect(ct.name['en-GB']).to.equal('Resource pickers');

          const { version } = ct;
          expect(version.modified).to.equal(version.created);
          expect(version.versionNo).to.equal('1.0');
          done();
        }
      );
    });
  });

  describe('repeat the same duplicate a single content type with a new name and id', () => {
    const mock = loadRecordedMock('duplicate_commit_contentType_repeat.json');
    it(`should update one existing content type`, (done) => {
      migratortronApi.post(
        'duplicate/commit?contentType&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(body.committed).to.equal(true);

          const contentTypes = body.contentTypes;
          expect(contentTypes).to.be.an('array');
          expect(contentTypes).to.have.a.lengthOf(1);

          const ct = contentTypes[0];
          expect(ct.id).to.equal('resourcePickers');
          expect(ct.name['en-GB']).to.equal('Resource pickers');

          const { version } = ct;
          expect(version.modified).to.not.equal(version.created);
          expect(version.versionNo).to.equal('2.0');
          done();
        }
      );
    });
  });
});
